import BrandSubscriptionServiceCallState from '../store/schema/BrandSubscriptionServiceCallState';
import { BlockedSendersMap } from '../store/schema/BrandsSubscriptionsStore';
import {
    getBrandsSubscriptionsService,
    GetBrandsSubscriptionsServiceResponse,
} from 'owa-brands-subscription';
import { orchestrator } from 'satcheljs';
import {
    loadBrandsSubscriptions,
    setServiceCallState,
    updateBrandsSubscriptions,
} from '../actions/internalActions';
import { getMailboxJunkEmailConfiguration } from 'owa-junkmail-configuration';

orchestrator(loadBrandsSubscriptions, async () => {
    setServiceCallState(BrandSubscriptionServiceCallState.InProgress);

    // Create a Map for easy lookups, since the list can get pretty big
    const blockedSendersMap: BlockedSendersMap = {};
    const blockedSendersAndDomains = (await getMailboxJunkEmailConfiguration())
        .BlockedSendersAndDomains;

    // Set the value for the blocked senders on the map
    blockedSendersAndDomains.forEach(blockedSender => {
        blockedSendersMap[blockedSender.toLowerCase()] = true;
    });

    const response: GetBrandsSubscriptionsServiceResponse = await getBrandsSubscriptionsService();
    if (response) {
        updateBrandsSubscriptions(response, blockedSendersMap);
        setServiceCallState(BrandSubscriptionServiceCallState.Succeeded);
    } else {
        setServiceCallState(BrandSubscriptionServiceCallState.Failed);
    }
});
